import axios from "axios";

export const DeleteTheoryApi = async (theorySecureId, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/admin/theory/delete?";
    const endpoint = `${BASED_URL}${path}theorySecureId=${theorySecureId}&token=${token}`;
    const response = axios.delete(endpoint);
    return response;
  } catch (error) {
    return error.response;
  }
};

export default DeleteTheoryApi;
